import { Line } from 'vue-chartjs'
import { interpolateCool } from 'd3-scale-chromatic'

export default {
  props: ['updates'],
  extends: Line,
  mounted () {
    const quantityPriceHistory = {}
    this.updates.forEach(update => {
      update.prices.forEach(price => {
        if (!quantityPriceHistory[price.quantity]) {
          quantityPriceHistory[price.quantity] = []
        }
        quantityPriceHistory[price.quantity].push({ t: new Date(update.createdAt), y: price.price })
      })
    })
    this.renderChart(
      {
        datasets: Object.entries(quantityPriceHistory).map(([quantity, history], index) => (
          {
            label: quantity,
            borderColor: interpolateCool(index / Object.values(quantityPriceHistory).length),
            backgroundColor: interpolateCool(index / Object.values(quantityPriceHistory).length),
            fill: false,
            data: history,
            steppedLine: 'after'
          }
        ))
      },
      {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            type: 'time',
            position: 'bottom',
            time: {
              minUnit: 'day'
            }
          }]
        }
      }
    )
  }
}
